import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";
import parse from "html-react-parser";

import icon_mail from "../images/icons/payments/mail.svg"
import icon_printer from "../images/icons/payments/printer.svg"
import icon_paypal from "../images/icons/payments/paypal.svg"
import icon_mastercard from "../images/icons/payments/mastercard.svg"
import icon_visa from "../images/icons/payments/visa.svg"
import icon_amex from "../images/icons/payments/amex.svg"
import icon_twint from "../images/icons/payments/twint.svg"
import icon_postfinance from "../images/icons/payments/postfinance.svg"
import icon_invoice from "../images/icons/payments/invoice.svg"


import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import Header from "./components/Header";
import Footer from "./components/Footer";

const Checkout = () => {
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));

    const [eventIdWorkshopsSaturday, setEventIdWorkshopsSaturday] = useState();
    const [eventIdWorkshopsSunday, setEventIdWorkshopsSunday] = useState();

    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);
    const [payment, setPayment] = useState({
        paymentMethodId: 0,
        deliveryMethodId: 0,
        insurance: false
    })

    const [orderInsurancePrice, setOrderInsurancePrice] = useState(0);

    const [onlyInvoiceTickets, setOnlyInvoiceTickets] = useState(false);

    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    const [isAgbChecked, setIsAgbChecked] = useState(false);

    const [submitError, setSubmitError] = useState("");

    const [promotioncode, setPromotioncode] = useState("");
    const [addedPromotionCodes, setAddedPromotionCodes] = useState([]);
    const [promotionError, setPromotionError] = useState({
        text: "",
        valid: false
    });

    const [totalSelectedWorkshopsSaturday, setTotalSelectedWorkshopsSaturday] = useState(0);
    const [totalSelectedWorkshopsSunday, setTotalSelectedWorkshopsSunday] = useState(0);

    const isButtonFinishOrderDisabled = payment.paymentMethodId === 0 || payment.deliveryMethodId === 0 || !isAgbChecked;

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [resourcesTranslation, setResourcesTranslation] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - addPaymentInfo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'addPaymentInfo'
        });
    }, [])

    useEffect(() => {
        if (!tickets || !eventIdWorkshopsSaturday || !eventIdWorkshopsSunday) return;
        setTotalSelectedWorkshopsSaturday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsSaturday).length);
        setTotalSelectedWorkshopsSunday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsSunday).length);
    }, [tickets, eventIdWorkshopsSaturday, eventIdWorkshopsSunday])

    useEffect(() => {
        requestResources();
        requestFormSettings();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
            getOrderInsurance();
        }
    }, [orderId]); //gets called when an order is started

    // Add promocodes to page if already existing in order
    useEffect(() => {
        if (order && Array.isArray(order.tickets)) {
            const codes = [];
            order.tickets.forEach(ticket => {
                if (ticket.promotionCode && !codes.includes(ticket.promotionCode)) {
                    codes.push(ticket.promotionCode);
                }
            });
            // Only update state if codes are different
            if (codes.length > 0 && (codes.length !== addedPromotionCodes.length || !codes.every(c => addedPromotionCodes.includes(c)))) {
                setAddedPromotionCodes(codes);
            }
        }
    }, [order]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.checkOut);
                setResourcesTranslation(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestFormSettings = async () => {
        try {
            const res = await axios.get(`form/formsettings`);
            setEventIdWorkshopsSaturday(res.data.eventIdWorkshopsSaturday)
            setEventIdWorkshopsSunday(res.data.eventIdWorkshopsSunday)
        } catch (error) {
            console.error(error);
        }
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            let updatedPayment = { ...payment, deliveryMethodId: updatedOrder.deliveryMethodId, paymentMethodId: updatedOrder.paymentMethodId };

            updatedPayment.insurance = updatedOrder.totalInsuranceAmount > 0;

            setPayment(updatedPayment);
            setOrder(updatedOrder);
            setTickets(updatedTickets);

            const allInvoiceTickets = updatedTickets.every(t => t.ticketTypeId === 819445);
            setOnlyInvoiceTickets(allInvoiceTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onAgbChange = (isAgbChecked) => {
        setIsAgbChecked(isAgbChecked);
    };

    const changeDeliveryType = async (deliveryMethodId) => {
        await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${deliveryMethodId}`)
            .then(() => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const changePaymentType = (paymentMethodId) => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${paymentMethodId}`)
            .then((res) => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const addPromotionToOrder = async () => {
        try {
            await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotioncode}`);

            setPromotionError({
                text: `${resources.PromocodeSuccess} (${promotioncode})`,
                valid: true
            });

            setAddedPromotionCodes((current) => [...current, promotioncode]);

            await loadOrder(orderId);
            setPromotioncode("");
        } catch (error) {
            setPromotionError({
                text: resources.PromocodeError,
                valid: false
            });
        }
    };

    const startDatatrans = () => {
        var baseRequestUrl = `https://datatrans.ticketino.com/Datatrans/${orderId}/DigitalSignature`;

        axios
            .get(baseRequestUrl)
            .then((res) => {
                let datatransFormId = "datatrans-" + new Date().getTime();
                var form =
                    "<form className='datatrans' id='" + datatransFormId + "'></form>";

                let container = document.getElementById("datatrans-form-placeholder");

                container.innerHTML += form;

                let element = document.getElementById(datatransFormId);

                // merchantId for testing
                // element.setAttribute("data-merchant-id", "1100004624");
                element.setAttribute("data-merchant-id", res.data.merchantId);
                element.setAttribute("data-amount", res.data.amount);
                element.setAttribute("data-currency", res.data.currency);
                element.setAttribute("data-refno", res.data.referenceNumber);
                element.setAttribute("data-reqType", res.data.reqType);
                element.setAttribute(
                    "data-upp-return-target",
                    res.data.uppReturnTarget
                );
                element.setAttribute("data-paymentMethod", res.data.paymentMethod);
                element.setAttribute("data-sign", res.data.digitalSignature);

                let domain = "https://" + window.location.host;

                let successUrl = domain + `/form/redirect/${language}/success/${orderId}`;
                let errorUrl = domain + `/form/redirect/${language}/error/${orderId}`;
                let cancelUrl = domain + `/form/redirect/${language}/cancel/${orderId}`;

                element.setAttribute("data-success-url", successUrl);
                element.setAttribute("data-error-url", errorUrl);
                element.setAttribute("data-cancel-url", cancelUrl);

                for (const key in res.data.userInfo) {
                    element.setAttribute(key, res.data.userInfo[key]);
                }

                for (const key in res.data.merchantSpecificParameters) {
                    element.setAttribute(key, res.data.merchantSpecificParameters[key]);
                }

                // start datatrans -> call the payment form
                window.Datatrans.startPayment({
                    form: "#" + datatransFormId,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onBackClick = async () => {
        navigate(-1)
    }

    const validateOrderStillExists = async () => {
        try {
            const latest = await getOrderByOrderId(orderId);
            if (!latest) return false;
            if (!latest?.id) return false;
            if (!Array.isArray(latest?.tickets) || latest.tickets.length === 0) return false;
            return true;
        } catch (e) {
            return false;
        }
    }

    const onSubmit = async () => {

        setSubmitError("");

        const exists = await validateOrderStillExists();
        if (!exists) {
            setSubmitError(resources?.OrderExpiredMessage || "Your reservation is no longer available. Please start again.");
            return;
        }

        if (order?.totalPrice > 0) {
            let dataTransProviders = [1, 7, 8, 9, 10, 14];

            let datatransProvider = dataTransProviders.findIndex((d) => d === payment.paymentMethodId) !== -1

            if (datatransProvider) {
                startDatatrans();
            } else {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            }
        } else {
            changePaymentTypeToFree();
        }
    }

    const getOrderInsurance = async () => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`);
            setOrderInsurancePrice(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    const setOrderInsurance = async () => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const removeOrderInsurance = async () => {
        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => {
                // Check if this is a workshop ticket (EventId 214329 or 214330)
                const isWorkshopTicket = tt.ticketType?.eventId === eventIdWorkshopsSaturday || tt.ticketType?.eventId === eventIdWorkshopsSunday;
                const displayPrice = isWorkshopTicket ? tt.ticketTypePrice + 15.00 : tt.ticketTypePrice;
                
                return (
                    <div key={tt.id}>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center flex-nowrap">
                                <label className="ticket-name-label mb-0">
                                    1x {tt.info?.name}
                                </label>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <label className="text-nowrap mb-0">
                                    {tt.ticketType?.currency} {displayPrice.toFixed(2)}
                                </label>
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    const mapPromotionCodes = () => {
        if (!addedPromotionCodes || addedPromotionCodes.length === 0) {
            return null;
        }

        return (
            <div className="row pt-2 pb-1">
                <div className="col-md-8 col-8">
                    <label>{resources.PromotionCodes || "Promotion Codes"}</label>
                </div>
                <div className="col-md-4 col-4 text-end">
                    <label>{addedPromotionCodes.join(", ")}</label>
                </div>
            </div>
        );
    };

    const mapExtraCosts = () => {
        return (
            <div>
                <div className="row pt-2 pb-1">
                    <div className="col-md-8 col-8">
                        <label>{resources.DeliveryCosts}</label>
                    </div>
                    <div className="col-md-4 col-4 text-end">
                        <label>{order.currency + " " + order?.deliverPaymentFee.toFixed(2)}</label>
                    </div>
                </div>
            </div>
        )
    }

    const mapInsurance = () => {
        return (
            <div>
                <div className="row pt-2">
                    <div className="col-md-10 col-8">
                        <label>{resources.TicketInsurance}</label>
                    </div>
                    <div className="col-md-2 col-4 text-end">
                        <label>
                            {order.currency + " " + order.totalInsuranceAmount.toFixed(2)}
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div id="datatrans-form-placeholder"></div>

            <Header language={language} pagePath="checkout" />

            <div className="page-container">

                {/* progress bar */}
                <div className="progressbar-wrapper">
                    <div className="progressbar-lines">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </div>

                    <div className="progressbar-steps">
                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/home`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 1" />
                            </div>
                            <div className="label">{resourcesTranslation?.ProgressTickets}</div>
                        </div>

                        <div className={`progress-step completed${countSaturdayTickets > 0 || countSundayTickets > 0 ? " cursor-pointer" : ""}`} onClick={() => {
                            if (countSaturdayTickets > 0) {
                                navigate(`/${language}/workshops-saturday`);
                            } else if (countSundayTickets > 0) {
                                navigate(`/${language}/workshops-sunday`);
                            }
                        }}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 2" />
                            </div>
                            <div className="label">
                                {resourcesTranslation?.ProgressWorkshops}<br />{resourcesTranslation?.ProgressOptional}
                            </div>
                        </div>

                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/address`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 3" />
                            </div>
                            <div className="label">{resourcesTranslation?.ProgressAdditionalInformation}</div>
                        </div>

                        <div className="progress-step active">
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 4" />
                            </div>
                            <div className="label">{resourcesTranslation?.ProgressCheckout}</div>
                        </div>
                    </div>
                </div>

                <div className="container wrapper">
                    {/*<div className="row mt-4">*/}
                    {/*    <div className="col-md-12 mb-1">*/}
                    {/*        <p className="text-subtitle">{resources.DeliveryOption}</p>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div className="mb-4">*/}
                    {/*    <div className="form-check mb-3">*/}
                    {/*        <input*/}
                    {/*            className="form-check-input me-2"*/}
                    {/*            type="radio"*/}
                    {/*            name="flexRadioDefault1"*/}
                    {/*            checked={payment.deliveryMethodId === 1 ? true : false}*/}
                    {/*            onClick={() => changeDeliveryType(1)}*/}
                    {/*            id="printAtHome"*/}
                    {/*        />*/}
                    {/*        <label*/}
                    {/*            className="d-inline"*/}
                    {/*            htmlFor="printAtHome"*/}
                    {/*        >*/}
                    {/*            <img htmlFor="mail" src={icon_mail} className="delivery_icon" alt="Mail Icon" />*/}
                    {/*            {resources.PrintAtHome}*/}
                    {/*            <p className="m-0 text-secondary delivery-description">*/}
                    {/*                {resources.PrintAtHomeDescription}*/}
                    {/*            </p>*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {
                        order.totalPrice > 0 &&
                        <>
                            <div className="row mt-5">
                                <div className="col-md-12 mb-1">
                                    <p className="text-subtitle">{resources.PaymentOption}</p>
                                </div>
                            </div>
                            <div className="mb-5">
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input me-2"
                                        type="radio"
                                        name="flexRadioDefault"
                                        checked={payment.paymentMethodId === 1 ? true : false}
                                        onClick={() => changePaymentType(1)}
                                        id="mastercard"
                                    />
                                    <label
                                        className="d-inline payment-names"
                                        htmlFor="mastercard"
                                    >
                                        <img src={icon_mastercard} className="payment_icon" alt="Mastercard Icon" />
                                        {resources.MasterCard}
                                        <p className="m-0 text-secondary payment-description">
                                            {/*{resources.MasterCardDesc}*/}
                                        </p>
                                    </label>
                                </div>

                                <div className="form-check mb-3 mt-4">
                                    <input
                                        className="form-check-input me-2"
                                        type="radio"
                                        name="flexRadioDefault"
                                        checked={payment.paymentMethodId === 7 ? true : false}
                                        onClick={() => changePaymentType(7)}
                                        id="visa"
                                    />
                                    <label
                                        className="d-inline payment-names"
                                        htmlFor="visa"
                                    >
                                        <img src={icon_visa} className="payment_icon" alt="Visa Icon" />
                                        {resources.Visa}
                                        <p className="m-0 text-secondary payment-description">
                                            {/*{resources.VisaDesc}*/}
                                        </p>
                                    </label>
                                </div>

                                {/*<div className="form-check mb-3 mt-4">*/}
                                {/*    <input*/}
                                {/*        className="form-check-input me-2"*/}
                                {/*        type="radio"*/}
                                {/*        name="flexRadioDefault"*/}
                                {/*        checked={payment.paymentMethodId === 8 ? true : false}*/}
                                {/*        onClick={() => changePaymentType(8)}*/}
                                {/*        id="amex"*/}
                                {/*    />*/}
                                {/*    <label*/}
                                {/*        className="d-inline payment-names"*/}
                                {/*        htmlFor="amex"*/}
                                {/*    >*/}
                                {/*        <img src={icon_amex} className="payment_icon" alt="Amex Icon" />*/}
                                {/*        {resources.AmericanExpress}*/}
                                {/*        <p className="m-0 text-secondary payment-description">*/}
                                {/*            */}{/*{resources.AmericanExpressDesc}*/}
                                {/*        </p>*/}
                                {/*    </label>*/}
                                {/*</div>*/}

                                {/*<div className="form-check mb-3 mt-4">*/}
                                {/*    <input*/}
                                {/*        className="form-check-input me-2"*/}
                                {/*        type="radio"*/}
                                {/*        name="flexRadioDefault"*/}
                                {/*        checked={payment.paymentMethodId === 9 ? true : false}*/}
                                {/*        onClick={() => changePaymentType(9)}*/}
                                {/*        id="postfinance"*/}
                                {/*    />*/}
                                {/*    <label*/}
                                {/*        className="d-inline payment-names"*/}
                                {/*        htmlFor="postfinance"*/}
                                {/*    >*/}
                                {/*        <img src={icon_postfinance} className="payment_icon" alt="Postfinance Icon" />*/}
                                {/*        {resources.PostFinance}*/}
                                {/*        <p className="m-0 text-secondary payment-description">*/}
                                {/*            {resources.PostFinanceDesc}*/}
                                {/*        </p>*/}
                                {/*    </label>*/}
                                {/*</div>*/}

                                {/*<div className="form-check mb-3">*/}
                                {/*    <input*/}
                                {/*        className="form-check-input me-2"*/}
                                {/*        type="radio"*/}
                                {/*        name="paypal"*/}
                                {/*        checked={payment.paymentMethodId === 10 ? true : false}*/}
                                {/*        onClick={() => changePaymentType(10)}*/}
                                {/*        id="paypal"*/}
                                {/*    />*/}

                                {/*    <label*/}
                                {/*        className="d-inline payment-names"*/}
                                {/*        htmlFor="paypal"*/}
                                {/*    >*/}
                                {/*        <img htmlFor="paypal" src={icon_paypal} className="payment_icon" alt="Paypal Icon" />*/}
                                {/*        {resources.PayPal}*/}
                                {/*        <p className="pt-1 m-0 text-secondary payment-description">*/}
                                {/*            {resources.PayPalDesc}*/}
                                {/*        </p>*/}
                                {/*    </label>*/}
                                {/*</div>*/}

                                <div className="form-check mb-3 mt-4">
                                    <input
                                        className="form-check-input me-2"
                                        type="radio"
                                        name="flexRadioDefault"
                                        checked={payment.paymentMethodId === 14 ? true : false}
                                        onClick={() => changePaymentType(14)}
                                        id="twint"
                                    />
                                    <label
                                        className="d-inline payment-names"
                                        htmlFor="twint"
                                    >
                                        <img src={icon_twint} className="payment_icon" alt="Twint Icon" />
                                        {resources.Twint}
                                        <p className="m-0 text-secondary payment-description">
                                            {/*{resources.TwintDesc}*/}
                                        </p>
                                    </label>
                                </div>

                                {/*{onlyInvoiceTickets &&*/}
                                {/*<div className="form-check mb-3 mt-4">*/}
                                {/*    <input*/}
                                {/*        className="form-check-input me-2"*/}
                                {/*        type="radio"*/}
                                {/*        name="flexRadioDefault"*/}
                                {/*        checked={payment.paymentMethodId === 2 ? true : false}*/}
                                {/*        onClick={() => changePaymentType(2)}*/}
                                {/*        id="invoice"*/}
                                {/*    />*/}
                                {/*    <label*/}
                                {/*        className="d-inline payment-names"*/}
                                {/*        htmlFor="invoice"*/}
                                {/*    >*/}
                                {/*        <img src={icon_invoice} className="payment_icon" alt="Invoice Icon" />*/}
                                {/*        {resources.PaymmentInvoice}*/}
                                {/*        <p className="m-0 text-secondary payment-description">*/}
                                {/*            */}{/*{resources.PaymentSmallFee}*/}
                                {/*        </p>*/}
                                {/*    </label>*/}
                                {/*</div>*/}
                                {/*}*/}

                            </div>
                        </>
                    }

                    {/* Promotion Code Section */}
                    {order.totalPrice > 0 &&
                        <>
                            <div className="mt-5 mb-4">
                                <p className="text-subtitle mb-2">{resources?.PromotionCodeTitle}</p>
                                <p dangerouslySetInnerHTML={{ __html: resources?.PromocodeDescription }}></p>
                                <div className="row">
                                    <div className="col-md-4 col-8 mb-3">
                                        <input className="form-control" placeholder="Code" value={promotioncode} onChange={(e) => setPromotioncode(e.target.value)} />
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-custom" disabled={promotioncode === ""} onClick={() => addPromotionToOrder()}>{resources?.Redeem}</button>
                                    </div>
                                </div>
                            </div>

                            {promotionError.text && (
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        {!promotionError.valid ?
                                            <p className="text-danger">{promotionError.text}</p> :
                                            <p className="text-success">{promotionError.text}</p>
                                        }
                                    </div>
                                </div>
                            )}
                        </>
                    }

                    {order.totalPrice > 0 &&
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <p className="text-subtitle mb-2 text-uppercase">{resources?.TicketInsurance}</p>
                                <div className="form-check mb-4">
                                    <input
                                        className="form-check-input me-3 "
                                        type="checkbox"
                                        checked={payment.insurance}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setOrderInsurance();
                                            } else {
                                                removeOrderInsurance();
                                            }
                                        }}
                                    />
                                    <label className="col-11 form-check-label fs-6" htmlFor="inlineCheckbox1">
                                        {parse(
                                            (orderInsurancePrice === 0
                                                ? resources.TicketInsuranceDescGeneric
                                                : (resources.TicketInsuranceDesc ?? "").replace("{@InsurancePrice}", orderInsurancePrice.toFixed(2))
                                            ) ?? ""
                                        )}
                                    </label>
                                </div>

                            </div>
                        </div>}

                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-subtitle mb-1 text-uppercase">{resources.Summary}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <>
                                {mapTickets()}

                                {(totalSelectedWorkshopsSaturday > 0 || totalSelectedWorkshopsSunday > 0) && (
                                    <>
                                        <hr className="ticket-separator" />

                                        <div className="row mt-1">
                                            <div className="col-md-8 col-8">
                                                <span>{resources.DiscountOnEntranceTicket}</span>
                                            </div>
                                            <div className="col-md-4 col-4 text-end">
                                                <span>- {order.currency} {((totalSelectedWorkshopsSaturday + totalSelectedWorkshopsSunday) * 15).toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <hr className="ticket-separator" />

                                {addedPromotionCodes.length > 0 && mapPromotionCodes()}
                                {payment.insurance && mapInsurance()}
                                {order.deliverPaymentFee > 0 && mapExtraCosts()}
                                <div className="row mt-1 mb-3">
                                    <div className="col-md-8 col-8">
                                        <span className="text-subtitle">
                                            {resources.Total}
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-4 text-end">
                                        <span className="text-subtitle">
                                            {order.currency} {order.totalPrice?.toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>

                    {/* AGB */}
                    <div className="row mt-5" onClick={() => onAgbChange(!isAgbChecked)}>
                        <div className="col-1 ps-md-4 fs-5 text-secondary">
                            <i className={`bi bi${(isAgbChecked) ? "-check" : ""}-square`}></i>
                        </div>
                        <div className="col-11 col-md-10 ps-md-0">
                            <label style={{ marginTop: "2px" }} dangerouslySetInnerHTML={{ __html: resources?.AGB }}></label>
                        </div>
                    </div>


                    {/* Buttons */}
                    <div className="row mt-5">
                        <div className="col-6">
                            <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                        </div>
                        <div className="col-6 text-end">
                            <button className="btn btn-custom" disabled={isButtonFinishOrderDisabled} onClick={() => onSubmit()}>{resources?.Buy}</button>
                        </div>
                    </div>

                    {submitError && (
                        <div className="row mt-3">
                            <div className="col-12">
                                <div className="alert alert-danger" role="alert">
                                    {submitError}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer language={language} />
        </>
    )
}

export default Checkout